/**
 * THEME JSON CONFIG CSS VARS
 * The following default component scss variables can be overwritten via theme configuration per brand.
 * If you need to add new one, please make sure to set a default value.
 * JSON Definition for Component with name "Example": testCssVar: "20px"
 * Resulting CSS var: $example-test-css-var: 20px;
 */

/* END THEME JSON CONFIG CSS VARS ******************************************************* */

.#{$prefix}form-message {
  position: relative;
  margin-top: 5px;
  display: flex;
  align-items: flex-start;
  gap: 8px;
  font-family: $copy-small-font-family;
  font-size: $copy-small-font-size;
  font-weight: $copy-small-font-weight;
  line-height: $copy-small-line-height;
  color: v(fontColor);
  word-break: break-word;
  /* for option-picker and radio-button in SAFARI BROWSER */
  width: 100%;
  justify-content: flex-start;

  span {
    position: relative;
    @include iconTextAligner(24px, $copy-small-line-height);
  }

  &.#{$prefix}info {
    fill: v(infoColor);

    eon-ui-icon,
    a {
      fill: v(infoColor);
    }
  }

  &.#{$prefix}success {
    fill: v(successColor);

    eon-ui-icon {
      fill: v(successColor);
    }
  }

  &.#{$prefix}error {
    fill: v(errorColor);

    eon-ui-icon,
    a {
      fill: v(errorColor);
    }
  }
}
